import { Component, Input, viewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserExperienceDialogComponent } from '../user-experience-dialog/user-experience-dialog.component';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TranslateService } from '@ngx-translate/core';
import { UserExperienceTableStore } from './user-experience-table.store';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { FileLinkInput } from '../../../../shared/components/kit/file-link/file-link.types';
import { dateColumn, nameColumn } from '../../../../shared/components/kit/table/table.fields';
import { UserGridItemObject } from '@it2go/types';
import { UserExperienceObject } from '@libs/types/src/user/object-type/user-experience.object';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { successDeleted } from '../../../content.error';

@Component({
    selector: 'app-user-experience-table',
    templateUrl: './user-experience-table.component.html',
    styleUrl: './user-experience-table.component.scss',
    providers: [UserExperienceTableStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
    ],
})
export class UserExperienceTableComponent extends SubscriptionComponent {
    protected readonly store = inject(UserExperienceTableStore);
    private readonly confirm = inject(ConfirmBuilder);
    private readonly dialogService = inject(BaseDialogService);
    private readonly translate = inject(TranslateService);


    @Input() user: UserGridItemObject | null = null;
    @Input() profile = false;
    @Input() canEdit = true;

    protected readonly tableComponent = viewChild(CardTableComponent);

    protected experienceColumns: TableColumn[] = [
        {
            name: 'file',
            type: TableColumnType.File,
            dataKey: null,
            data: (item: UserExperienceObject) => {
                return item.file ? <FileLinkInput>{ path: item.file, name: item.name } : null;
            },
        },
        dateColumn,
        {
            name: 'hours',
        },
        nameColumn,
    ];

    protected experienceDetail(item?: any) {
        if (!this.canEdit) return;
        const dataBase = { user: this.user, profile: this.profile };

        this.dialogService.open(UserExperienceDialogComponent, {
            header: this.translate.instant('common.addNewRecord'),
            data: item ? { experience: item, ...dataBase } : dataBase,
        }).onClose.subscribe(() => {
            this.tableComponent()?.reload();
        });
    }

    protected deleteExperience(item: any) {
        if (!this.user?.id || !this.canEdit) return;
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteUserExperience({
                    input: { id: item.item.id, userId: this.user!.id! },
                    profile: this.profile,
                });
                successDeleted();
                this.tableComponent()?.reload();
            },
            item,
        );
    }

}
